"use memo"

import { cleanFullAddress, PropertyAddress } from '@urbanx/agx-ui-components'
import {
  AutopilotTaskDto,
  TaskCategoryTaskType,
  TaskCategoryWorkflowType,
} from '@urbanx/agx.activities.client'
import { AuthContext } from '@urbanx/agx.auth.client'
import { MenuTitles } from 'constants/menu'
import { useSelectedAgency, useSelectedCampaign } from 'hooks'
import { ContentLayout, PageLayout } from 'layout'
import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { AgxButton } from '@urbanx/agx.ui-components2'
import Tasks from 'components/tasks/Tasks'
import { ContractTerminateModal } from './contract-terminate-modal'

const ContractTasks = () => {
  const { contractId } = useParams()
  const { userAccount } = useContext(AuthContext)
  const { agency } = useSelectedAgency()
  const { campaign } = useSelectedCampaign()

  const [showTerminateConfirmation, setShowTerminateConfirmation] =
    useState(false)
  const [allTasks, setAllTasks] = useState<AutopilotTaskDto[]>([])

  const onTerminate = () => {
    setShowTerminateConfirmation(true)
  }

  const terminatedTask = allTasks.find(
    (t) => t.category?.taskType === TaskCategoryTaskType.Termination
  )

  const handleTasksChange = (tasks: AutopilotTaskDto[]) => {
    setAllTasks(tasks)
  }

  // Get unlocked contract tasks to determine if terminate button should be disabled
  const unlockedContractTasks = allTasks.filter(
    (t) =>
      !t.isLocked &&
      t.category?.workflowType === TaskCategoryWorkflowType.Contract
  )

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(campaign?.address as PropertyAddress)}`}
      isCampaignsSection={true}
    >
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={MenuTitles.CONTRACT_TASKS}
        isContracts={true}
        secondaryActions={
          <AgxButton
            id={'btnTerminateContract'}
            text={'Terminate contract'}
            variant={'link'}
            danger
            onClick={onTerminate}
            disabled={
              unlockedContractTasks.length === 0 ||
              (terminatedTask && !terminatedTask.isLocked)
            }
          />
        }
      >
        <Tasks
          campaignId={campaign?.campaignId ?? ''}
          contractId={contractId}
          primaryWorkflowType={TaskCategoryWorkflowType.Contract}
          onTasksChange={handleTasksChange}
        />

        <ContractTerminateModal
          isOpen={showTerminateConfirmation}
          setIsOpen={setShowTerminateConfirmation}
        />
      </ContentLayout>
    </PageLayout>
  )
}

export default ContractTasks
